/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query'
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  BadRequestResponse,
  ForbiddenResponse,
  InternalServerErrorResponse,
  NotFoundResponse,
  SearchOrganization200,
  SearchOrganizationParams,
  UnauthorizedResponse
} from '.././model'
import { customInstance } from '../../custom-instance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * @summary Search for cases and documents within an organization
 */
export const searchOrganization = (
    organizationId: string,
    params: SearchOrganizationParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SearchOrganization200>(
      {url: `https://api.app.usesky.ai/organizations/${organizationId}/search`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getSearchOrganizationQueryKey = (organizationId: string,
    params: SearchOrganizationParams,) => {
    return [`https://api.app.usesky.ai/organizations/${organizationId}/search`, ...(params ? [params]: [])] as const;
    }

    
export const getSearchOrganizationQueryOptions = <TData = Awaited<ReturnType<typeof searchOrganization>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(organizationId: string,
    params: SearchOrganizationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchOrganization>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchOrganizationQueryKey(organizationId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchOrganization>>> = ({ signal }) => searchOrganization(organizationId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchOrganization>>, TError, TData> & { queryKey: QueryKey }
}

export type SearchOrganizationQueryResult = NonNullable<Awaited<ReturnType<typeof searchOrganization>>>
export type SearchOrganizationQueryError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

/**
 * @summary Search for cases and documents within an organization
 */
export const useSearchOrganization = <TData = Awaited<ReturnType<typeof searchOrganization>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    params: SearchOrganizationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchOrganization>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSearchOrganizationQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



